export default __webpack_public_path__ + "static/media/bread-bg.a882b58f.jpg";